import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ToastType } from '../../../toast-types';

@Component({
  selector: 'lib-toastv2',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToastV2Component implements OnInit, AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  self: any;
  messageKey: string;
  @Input() type: ToastType;

  @ViewChild('relativeContainer') relativeContainer: ElementRef;
  @ViewChild('toastBody') toastBody: ElementRef;

  closeLabel: string;

  public ToastType = ToastType;

  constructor(
    private translocoService: TranslocoService,
    private zone: NgZone,
  ) {}

  ngOnInit(): void {
    this.closeLabel =
      this.translocoService.getActiveLang() === 'sv'
        ? 'Stäng meddelande'
        : 'Close message';
  }

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        const bodyHeight = this.toastBody.nativeElement.offsetHeight;
        const heightInRem = bodyHeight / 16;
        this.relativeContainer.nativeElement.style.height =
          heightInRem + 0.5 + 'rem';
      });
    });
  }

  hide() {
    this.self.hide();
  }
}
